import {Component} from '@angular/core';

@Component({
  selector: 'app-block-temp',
  styles: [
    `
      :host {
        text-align: center;
        color: #ffffff;
      }
      .container {
        height: 100vh;

        display: flex;
        justify-content: center;
        align-items: center;
      }

      .loading {
        display: flex;
        flex-direction: row;
      }
      .loading__letter {
        font-size: 50px;
        font-weight: normal;
        letter-spacing: 4px;
        padding: 10px;
        font-family: 'Audiowide';
        color: white;
        font-weight: 500;
        line-height: 1.2;
        margin-bottom: 0.5rem;
        animation-name: bounce;
        animation-duration: 2s;
        animation-iteration-count: infinite;
      }

      .loading__letter:nth-child(2) {
        animation-delay: 0.1s;
      }
      .loading__letter:nth-child(3) {
        animation-delay: 0.2s;
      }
      .loading__letter:nth-child(4) {
        animation-delay: 0.3s;
      }
      .loading__letter:nth-child(5) {
        animation-delay: 0.4s;
      }
      .loading__letter:nth-child(6) {
        animation-delay: 0.5s;
      }
      .loading__letter:nth-child(7) {
        animation-delay: 0.6s;
      }
      .loading__letter:nth-child(8) {
        animation-delay: 0.8s;
      }
      .loading__letter:nth-child(9) {
        animation-delay: 1s;
      }
      .loading__letter:nth-child(10) {
        animation-delay: 1.2s;
      }

      @keyframes bounce {
        0% {
          transform: translateY(0px);
        }
        40% {
          transform: translateY(-40px);
        }
        80%,
        100% {
          transform: translateY(0px);
        }
      }

      @media (max-width: 700px) {
        .loading__letter {
          font-size: 50px;
        }
      }

      @media (max-width: 340px) {
        .loading__letter {
          font-size: 40px;
        }
      }
    `,
  ],
  template: `
    <div class="container">
      <div class="loading">
        <div class="loading__letter"></div>

        <!-- <div class="loading__letter">°</div> 
  <div class="loading__letter">°</div> 
  <div class="loading__letter">°</div> 
  <div class="loading__letter">°</div>  -->
      </div>
    </div>
  `,
})
export class BlockTemplateComponent {}
